<template>
  <div class="newscard">

    <v-card
      class="mx-auto newsCard myBoxShadow myBorderRadius-important maxh"

    >
      <!--        max-width="400"-->
      <!--        :class="{pointer: hasDeepLink}"-->
      <div class="d-flex justify-center">
        <img class="newsCardImage" :class="{bigger:showAll}"
             v-if="news.image" :src="news.image"
        >
      </div>

      <!--      <v-img-->
      <!--        v-if="job.image"-->
      <!--        :src="job.image"-->
      <!--        :height="showAll ? '250px':'200px'"-->
      <!--        class="newsCardImage"-->
      <!--      ></v-img>-->

      <v-list-item>

        <v-list-item-content>
<!--          <div class="text-center" v-if="showAll && news.image">-->
<!--            <img :src="news.image" class="bigImage">-->
<!--          </div>-->
          <!--                    <div class=" bigImage text-left" v-if="showAll && news.image"-->
          <!--                         :style="{ backgroundImage: 'url(&quot;' + news.image + '&quot;)'}">-->
          <!--                    </div>-->
          <div class="spacer-10"></div>
          <!--                    <div>ID: {{news.id}}</div>-->
          <h1 class="text-none" v-if="showAll">{{ news.title }}</h1>
          <h3 class="text-none" v-else>{{ news.title }}</h3>
          <!--                list item title renders text in one line with ...-->
          <!--                <v-list-item-title class="headline">{{news.title}}</v-list-item-title>-->
          <v-list-item-subtitle>Nachricht vom {{ displayDate }}</v-list-item-subtitle>
        </v-list-item-content>


      </v-list-item>

      <!--        <v-card-title>-->
      <!--            {{news.title}}-->
      <!--        </v-card-title>-->

      <!--        <v-card-subtitle>-->
      <!--            {{ddate}}-->
      <!--        </v-card-subtitle>-->

      <v-card-text style="padding-bottom: 65px">
        <div v-if="showAll" v-html="news.additionalText"></div>
        <div v-else class="someLiner">
          {{ stripedHtml }}
        </div>
        <!--            <p>{{news.text}}</p>-->
        <!--            <p v-if="showAll" v-html="news.additionalText"></p>-->
      </v-card-text>


      <v-card-actions>
        <v-list-item class="grow">
          <!--                v-row justify="end"-->
          <v-row align="center" class="bigger-input">
            <!--                    <v-btn class="mr-3" text @click.native.passive="clickLink">-->
            <!--                        Öffnen-->
            <!--                        &lt;!&ndash;                        <v-icon right medium>mdi-share-variant</v-icon>&ndash;&gt;-->
            <!--                    </v-btn>-->

            <v-btn v-if="!showAll"
                   class="text-none okBtn rounded100" rounded=""
                   @click.native.passive.stop="gotoBeitrag(news)"
            >Mehr lesen
            </v-btn>
            <div class="flex-grow-1"></div>
            <v-btn class="rounded100" icon @click.native.passive.stop="share">
              <v-icon medium>mdi-share-variant</v-icon>
            </v-btn>

            <!--                    <v-btn text @click.native.passive="share">-->
            <!--                        Share-->
            <!--                        <v-icon right medium>mdi-share-variant</v-icon>-->
            <!--                    </v-btn>-->
          </v-row>
        </v-list-item>
      </v-card-actions>

      <!--        <div class="lightbox d-flex justify-center align-center maxh"-->
      <!--             @click.passive="showLightbox = false"-->
      <!--             v-if="showLightbox">-->

      <!--            <div class="inner" v-if="hasMoreImages" style="height: 80%; max-height: 500px;">-->
      <!--                <v-carousel-->
      <!--                        @click.native.passive.stop=""-->
      <!--                        height="100%"-->
      <!--                        hide-delimiter-background-->
      <!--                        v-model="sliderKey"-->
      <!--                        style="background: transparent"-->
      <!--                >-->
      <!--                    &lt;!&ndash;                    <v-carousel-item :key="1">&ndash;&gt;-->
      <!--                    &lt;!&ndash;                        <v-sheet&ndash;&gt;-->
      <!--                    &lt;!&ndash;                                @click.native.passive="showLightbox = false"&ndash;&gt;-->
      <!--                    &lt;!&ndash;                                height="100%" :style="{ 'background-image': 'url(' + item.image + ')' }">&ndash;&gt;-->
      <!--                    &lt;!&ndash;                        </v-sheet>&ndash;&gt;-->
      <!--                    &lt;!&ndash;                    </v-carousel-item>&ndash;&gt;-->
      <!--                    <v-carousel-item v-for="(mi, index) in allImages" :key="index + 1">-->
      <!--                        <v-sheet-->
      <!--                                @click.native.passive="showLightbox = false"-->
      <!--                                height="100%">-->
      <!--                            <div class="sliderImg" :style="{ 'background-image': 'url(' + mi + ')' }"></div>-->
      <!--                        </v-sheet>-->
      <!--                    </v-carousel-item>-->
      <!--                </v-carousel>-->
      <!--                <div class="close pointer" @click.passive="showLightbox = false">-->
      <!--                    <v-icon color="white" large>mdi-close-thick</v-icon>-->
      <!--                </div>-->
      <!--            </div>-->

    </v-card>

    <!--    <div class="box" :style="{ backgroundImage: 'url(&quot;' + category.image + '&quot;)'}">-->
    <!--        <div class="bottom">-->
    <!--            <h3>{{news.title}}</h3>-->
    <!--&lt;!&ndash;            <div class="s">Description</div>&ndash;&gt;-->
    <!--        </div>-->
    <!--    </div>-->

    <div class="pt-7 text-center" v-if="showAll">
      <v-btn rounded class="text-none btn-df" @click.native.passive="$ebus.$emit('goBack')">
        Weitere Nachrichten
      </v-btn>
    </div>


  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import {noHtml} from "@/vendor/util";
// import {displayDate} from "@/vendor/util";

export default {
  props: {
    news: {
      type: Object,
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  name: "NewsCard",
  metaInfo() {
    return {

      title: this.news.title,
      meta: [
        {
          name: 'description',
          content: 'Aktuelles: ' + this.news.title + ' ' + this.stripedHtml
        },
        {property: 'og:title', content: this.news.title},
        {property: 'og:site_name', content: 'Aktuelles'},
        {
          property: 'og:description',
          content: 'Aktuelles: ' + this.news.title + ' ' + this.stripedHtml
        },
        {property: 'og:type', content: 'article'},
        {property: 'og:published_time', content: this.news.publishDate},
        {property: 'og:url', content: window.location.href},
        {property: 'og:image', content: '' + this.news.image}
      ]
    }
  },
  data: () => ({
    // ddate: '',
    // showLightbox: false,
  }),

  // watch: {
  //     news: {
  //         handler: function handler(newVal, oldVal) {
  //             if (newVal.createdAt) {
  //                 this.updateDdate();
  //             }
  //         },
  //         deep: true,
  //     }
  // },
  // updated(){
  //     console.log('News updated');
  //     this.updateDdate();
  // },
  computed: {
    stripedHtml() {
      if (!this.news) {
        return '';
      }
      return noHtml(this.news.additionalText) || "";
    },
    displayDate() {
      let d = this.$options.filters.weekDayMonth(this.news.publishDate, true);
      return d;
    }
    //     hasDeepLink() {
    //         let link = this.news.link;
    //         return (link && link.indexOf('#') !== -1);
    //     }
  },
  mounted() {
    this.init();

    if (this.showAll && this.news.id) {
      let nId = '' + this.news.id;
      ebus.$emit('markNewsVisited', nId);
      console.log('Mark news as read: ' + nId);
    } else {
      if (!this.news.id) {
        console.log('this.news.id is null');
      }
    }

  },
  methods: {
    // updateDdate() {
    //     this.ddate = this.$options.filters.weekDayMonth(this.news.createdAt, true);
    //     console.log('ddate = ' + this.ddate);
    // },
    init() {
      // this.ddate = displayDate(new Date(this.news.createdAt));
      // this.updateDdate();
    },
    gotoBeitrag(news) {
      this.$router.push({name: 'Nachricht', params: {newsId: news.id}});
    },
    // clickLink() {
    //     if (this.hasDeepLink) {
    //         let l = this.news.link;
    //         l = l.substring(l.indexOf('#') + 2, l.length);
    //
    //         if (l.startsWith('Speise')) {
    //             let iid = l.substring(7, l.length);
    //             // alert(iid);
    //             this.$router.push({name: 'Speise', params: {itemId: iid}});
    //         } else {
    //             this.$router.push({name: l});
    //         }
    //         // }else  if(l.startsWith('Speise')){
    //         //     let iid = l.substring(7,l.length);
    //         //     alert(iid);
    //         //     this.$router.push({name: 'Speise', params: {itemId: iid}});
    //         // }
    //
    //
    //         // window.location = this.news.link;
    //     }
    // },
    share() {
      let title = this.news.title;
      let text = this.stripedHtml;
      let link = window.location.href;

      try {
        window.navigator.share({
          title: title,
          text: text,
          url: link,
        }); // share the URL of MDN
      } catch (e) {
        console.log('Error in share: ' + e.message);

        let bn = store.state.brandName;

        let body = text + ' \n \n' +
          'Nachrichten von ' + bn + ' auf:  \n' +
          link;
        body = encodeURIComponent(body);
        text = encodeURIComponent(text);
        let mailto_link = 'mailto:?subject=' + bn + ': ' + text + '&body=' + body;
        let win = window.open(mailto_link);//, '_blank');
        win.focus();
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.newsCard {
  overflow: hidden;
}

h2, h3, h4, h5 {
  text-transform: none;
}

img.newsCardImage {
  //margin-top: 12px;
  border-radius: 25px;
  width: 100%;
  height: auto;
  //height: auto;
  //max-height: 220px;

  &.bigger {
    //max-height: 290px;
  }
}

.newscard {
  padding-bottom: 20px;
  height: 100%;

  h1 {
    font-size: 1.7rem;
  }
}

.someLiner {
  height: 74px;
  max-height: 74px;
  overflow-y: hidden;
}

.bigImage {
  background-position: left;
  //background-position: 0 100%; //focused corner is bottom left
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: $box-border-radius;
  max-width: 100%;
}

.newsCard ::v-deep .v-btn__content {
  font-size: 1rem;
}

.newsCard ::v-deep .headline {
  letter-spacing: 0.070rem !important;
}

.newsCard ::v-deep .v-card__actions {
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
  padding-bottom: 0;
}

.newsCard ::v-deep .v-icon {
  font-size: 25px;
}

///////////////////////////
.lightbox {
  pointer-events: all;
  transition: all 0.4s ease;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 55;
  width: 100%;
  height: 100%;
  background-color: rgba(black, 0.7);

  .inner {
    display: inline-block;
    width: 600px;
    position: relative;

    .close {
      z-index: 5;
      position: absolute;
      top: -10px;
      right: -10px;
      padding: 15px;
    }
  }
}

.device-xs {
  .lightbox ::v-deep .close {
    position: fixed;
    top: 75px;
    left: 15px
  }
}


</style>
